import React from 'react';

function LandingPage() {


  return (
    <div className="landing-page container">
      <div className="h5 mt-5 mb-2">{/*I like to build things*/}My Projects</div> 
      <br />

      <div className="text-bold">Active Projects</div>

      
      <a href="https://github.com/sayil/dangerously">dangerously</a> - Run Claude Code autonomously in an isolated Docker container (open source) <br />
      <a href="https://learnunscripted.com">learnunscripted.com</a> - Leetcode for soft skills <br />
      <a href="https://nav401k.com">nav401k.com</a> - Optimize retirement vehicles <br />
     
      
      

      <br />
      <div className="text-bold">Abandoned Projects</div>

      <a href="https://anyspark.io">anyspark.io</a> - Make working with content creators as easy as buying ads on Google  <br />
      <a href="https://bitprops.io">bitprops.io</a> - Simplified real estate investing <br />
      <a href="https://clutchpotato.com">clutchpotato.com</a> - Custom cover letters to make job applications shine <br />
      <a href="https://datadelve.netlify.app">datadelve</a> - Ask your data anything <br />
      <a href="/envelope-math">envelope math</a> - Practice number sense and estimation skills <br />
      <a href="https://micromine.io">micromine.io</a> - Find your first 10 customers <br />
      <a href="https://placelift.io">placelift.io</a> - Home renovation management <br />
      <a href="https://sourcelift.netlify.app">sourcelift</a> - Access structured data from any source <br />
      <a href="https://threedaily.co">threedaily.co</a> - Convert long-term health goals into three daily tasks <br />
      <a href="https://winfluence.app">winfluence.app</a> - Lovable for content creation <br />
      

    </div>
    
  );
}

export default LandingPage;
